export default __webpack_public_path__ + "321a8e98bb64ea7d5a15c426757d14fe.png";